export default async function GetVendorDetailsById(id) {
    let url = window.RealestateService+  `/api/Vendor/GetVendorDetailsById?id=${id}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}